













































import Vue from 'vue';
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { IResponse, IAuthModel, IDialog } from '@/interfaces/objects';
import { authService } from '@/services/auth.service';
import { AUTH_MOBILE_REQUEST, AUTH_OTP_REQUEST } from '@/actions';

@Component({ components: {}, $_veeValidate: { validator: 'new' } })
export default class AuthComponent extends Vue {
    private isBusy: boolean = false;
    private isValid: boolean = false;
    private model: IAuthModel;
    private dictionary: {};
    private dialog: IDialog;
    constructor() {
        super();
        this.model = {
            mobile: '',
            otp: '',
            stage: 'mobile',
            token: '',
        };
        this.dictionary = {
            custom: {
                mobile: {
                    required: () => 'Mobile Number can not be empty',
                    max: 'The mobile field may not be greater than 10 characters',
                },
                otp: {
                    required: () => 'Otp Number can not be empty',
                    max: 'The otp field may not be greater than 6 characters',
                },
            },
        };
        this.dialog = {
            title: 'Authentication Error',
            message: '',
            visible: false,
        };
    }
    public created() {
        // not used
    }
    public mounted() {
        this.$validator.localize('en', this.dictionary);

        const wrapper = document.getElementsByClassName(
            'wrapper',
        )[0] as HTMLElement;
        const style = window.getComputedStyle(wrapper);
        const height = style.height;
        // we want our form to always center no matter what the size so we take
        // height / 2 and * by -1 to convert to a negative value. - BEN
        wrapper.style.marginTop = `calc((${height} / 2) * -1)`;
    }

    private async _submitMobile(): Promise<void> {
        if (await this.$validator.validate('mobile')) {
            this.isBusy = true;
            this.$store.dispatch(AUTH_MOBILE_REQUEST, this.model)
            .then((response) => {
                if (response.success) {
                    this.model.stage = response.data.stage;
                } else {
                    let msg = response.data.message;
                    if (msg === null || msg === undefined)  {
                        msg = response.data;
                    }
                    this.dialog.message = msg;
                    this.dialog.visible = true;
                }
                this.isBusy = false;
            })
            .catch((error) => {
                this.isBusy = false;
                this.dialog.message = 'Something went wrong! Please try again!';
                this.dialog.visible = true;
            });
        }
    }
    private async _submitOtp(): Promise<void> {
        if (await this.$validator.validate('otp')) {
            this.isBusy = true;
            this.$store.dispatch(AUTH_OTP_REQUEST, this.model)
            .then((response) => {
                if (response.success) {
                    this.authChanged();
                } else {
                    let msg = response.data.message;
                    if (msg === null || msg === undefined)  {
                        msg = response.data;
                    }
                    this.dialog.message = msg;
                    this.dialog.visible = true;
                }
                this.isBusy = false;
            })
            .catch((error) => {
                this.isBusy = false;
                this.dialog.message = 'Something went wrong! Please try again!';
                this.dialog.visible = true;
            });
        }
    }

    @Emit('authChanged')
    private authChanged() {
        // Auth Event
    }
}
